"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../BaseComponent");
/**
 * Gestion du mode CardElement qui importe directement tout un formulaire de paiement
 * L'alternative est CardElements
 */
var StripeForm = /** @class */ (function (_super) {
    __extends(StripeForm, _super);
    function StripeForm($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        return _this;
    }
    StripeForm.prototype.bind = function () {
        this.initEvents();
    };
    StripeForm.prototype.getElementStripForm = function () {
        return $('#payment-form');
    };
    /**
     * Initialisation du formulaire explosé en plusieurs éléments avec
     * chargement de chaque élément du formulaire séparément
     */
    StripeForm.prototype.initEvents = function () {
        var _this = this;
        var submitting = false;
        var $form = this.getElementStripForm();
        var stripePublicKey = $form.data('stripe-public-key');
        // @ts-ignore
        var stripe = new Stripe(stripePublicKey);
        // Create an instance of Elements.
        var elements = stripe.elements();
        var elementStyles = {
            base: {
                color: '#32325D',
                fontWeight: 500,
                fontFamily: '"Open Sans", sans-serif',
                fontSize: '16px',
                //fontSmoothing: 'antialiased',
                '::placeholder': {
                    color: '#CFD7DF'
                },
                ':-webkit-autofill': {
                    color: '#e39f48'
                }
            },
            invalid: {
                color: '#E25950',
                '::placeholder': {
                    color: '#FFCCA5'
                }
            }
        };
        var elementClasses = {
            focus: 'focused',
            empty: 'empty',
            invalid: 'invalid'
        };
        var cardNumber = elements.create('cardNumber', {
            style: elementStyles,
            classes: elementClasses
        });
        cardNumber.mount('#cardNumber');
        var cardExpiry = elements.create('cardExpiry', {
            style: elementStyles,
            classes: elementClasses
        });
        cardExpiry.mount('#cardExpiry');
        var cardCvc = elements.create('cardCvc', {
            style: elementStyles,
            classes: elementClasses
        });
        cardCvc.mount("#cardCvc");
        var elementItems = [cardNumber, cardExpiry, cardCvc];
        // A stack with specific form elements errors to avoid duplicate error
        // (after field and in form bottom global)
        var elementsErrorsStack = [];
        // Déclaration de la gestion des erreurs sur chaque élément du formulairem
        elementItems.forEach(function (element) {
            element.on('change', function (event) {
                submitting = false;
                var errorElementId = '#' + event.elementType + 'Error';
                var errorElement = $(errorElementId);
                if (event.error) {
                    // Specific error attached to an element
                    if (errorElement !== undefined && errorElement.length) {
                        errorElement.html(event.error.message).removeClass('hide');
                        elementsErrorsStack[event.elementType] = event.error.code;
                    }
                    else {
                        // If possible case, then process global error at the bottom of the form
                        $('#globalError').html(event.error.message).removeClass('hide');
                    }
                }
                else {
                    // If field is complete,
                    if (event.complete !== undefined && event.complete) {
                        // If there is no more error, then hide error
                        if (elementsErrorsStack[event.elementType] !== undefined) {
                            errorElement.html('').addClass('hide');
                            delete elementsErrorsStack[event.elementType];
                        }
                        // Forward focus/cursor to next field via label
                        if (event.elementType !== undefined) {
                            // From cardNumber to cardExpriry
                            if (event.elementType === 'cardNumber')
                                $('#labelExpiry').click();
                            // From cardExpiry to cardCvc
                            if (event.elementType === 'cardExpiry')
                                $('#labelCvc').click();
                            if (event.elementType === 'cardCvc') {
                                var $cardLabel = $('#cardLabel');
                                if ($cardLabel !== undefined && $cardLabel.length > 0) {
                                    // Move to card label which is present
                                    $('#labelCardLabel').click();
                                }
                                else {
                                    // Move to submit button
                                    $('#card-button').focus();
                                }
                            }
                        }
                    }
                }
            });
        });
        this.getElementStripForm().on('submit', function (e) {
            e.preventDefault();
            var stripeClientSecret = $form.data('stripe-client-secret');
            if (!submitting) {
                submitting = true;
                // Initialisation du paiement
                _this.processPayment(stripe, cardNumber, stripeClientSecret);
            }
        });
    };
    ;
    /*
     * Envoi du formulaire à Stripe pour précéder à la validation des infos de la carte.
     * Si le 3DSecure est activé, alors une modale va s'ouvrir pour gérer les interactions avec le client.
     */
    StripeForm.prototype.processPayment = function (stripe, card, clientSecret) {
        var _this = this;
        this.changeLoadingState(true);
        // Vérification que le total à payer n'a pas changé entre temps
        // L'utilisateur peut avoir modifié son panier, dans ce cas on devra :
        //   * soit recharger la page, *
        //   * soit recharger le clientSecret si possible...
        // Si la modification du montant est mise à jour à chaque manipulation
        // (ajout, retrait, modif mode livraison...) du panier cette étape n'est pas utile
        stripe
            // Etape 1
            // Envoi des données bancaire à Stripe (échange Stripe (iframe) à Stripe(serveur))
            // Si le 3DSecure est activé, alors une modale va s'ouvrir pour gérer les interactions avec le client.
            .confirmCardPayment(clientSecret, { payment_method: { card: card } })
            // Etape 2 : gestion erreur ou succès
            .then(function (result) {
            if (result.error) {
                // Affichage d'un message d'erreur
                _this.showError(result.error.message);
                // Déplocage du bouton d'envoi du formulaire
                var submitting = false;
            }
            else {
                // En cas de succès on post le formulaire à /mon-panier/paiement
                // Qui traitera la validation côté serveur et la création de la commande en cas de réel succès
                // Puis la redirection
                _this.paymentSuccess(clientSecret, stripe);
            }
        });
    };
    ;
    /* ------- Post-payment helpers ------- */
    /**
     * Dès que la validation de la carte de du paiement est passée :
     *   - affichage d'un message de succès (optionnel car redirection dans la foulée...)
     *   - récupèration du PaymentIntent
     *   - puis redirection de l'utilisateur
     */
    StripeForm.prototype.paymentSuccess = function (clientSecret, stripe) {
        var _this = this;
        stripe.retrievePaymentIntent(clientSecret).then(function (result) {
            var paymentIntent = result.paymentIntent;
            // Insertion du paymentIntentToken et du paymentMethodToken dans le
            // formulaire HTML avant de le transmettre au serveur
            var form = document.getElementById("payment-form");
            var hiddenPaymentIntent = document.createElement('input');
            hiddenPaymentIntent.setAttribute('type', 'hidden');
            hiddenPaymentIntent.setAttribute('name', 'paymentId');
            hiddenPaymentIntent.setAttribute('value', paymentIntent.id);
            form.appendChild(hiddenPaymentIntent);
            // Envoi réel du formulaire sans les champs de données bancaire qui sont chez Stripe
            // form.submit();
            window.location.href = '/mon-panier/paiement-succes?paymentId=' + paymentIntent.id;
            _this.changeLoadingState(false);
        });
    };
    ;
    /**
     * Gestion de l'affichage de l'erreur
     */
    StripeForm.prototype.showError = function (errorMsgText) {
        this.changeLoadingState(false);
        var errorMsg = document.querySelector('.sr-field-error');
        errorMsg.textContent = errorMsgText;
        setTimeout(function () {
            errorMsg.textContent = '';
        }, 4000);
    };
    ;
    /**
     * Affichage d'un spinner le temps du chargement
     */
    StripeForm.prototype.changeLoadingState = function (isLoading) {
        if (isLoading) {
            document.querySelector('button').disabled = true;
            document.querySelector('#spinner').classList.remove('hidden');
            document.querySelector('#button-text').classList.add('hidden');
        }
        else {
            document.querySelector('button').disabled = false;
            document.querySelector('#spinner').classList.add('hidden');
            document.querySelector('#button-text').classList.remove('hidden');
        }
    };
    return StripeForm;
}(BaseComponent_1.default));
exports.default = StripeForm;
;
